<div>
    <div class="container-fluid bg-white p-0">
        <ClientLogo v-if="this.$route.name != 'behalf_application'" />
        <BreadCrumb label="Vehicle Finance Application" />
        
        <div class="signio-container" v-if="data_ready">
            <!-- Mobile step title - only visible on mobile -->
            <h4 class="mobile-step-title">
                {{ cards[current_step].title }} <small class="text-muted">(Step {{ current_step + 1 }}/{{ cards.length }})</small>
            </h4>
            
            <!-- Progress bar -->
            <div class="signio-progress-container">
                <div class="step-indicators">
                    <div v-for="(step, index) in cards" :key="index" 
                         class="step-indicator" 
                         :class="{ 
                            'active': index === current_step, 
                            'completed': step.is_valid 
                         }"
                         @click="index < current_step ? current_step = index : null">
                        <div class="step-number">{{ index + 1 }}</div>
                        <div class="step-title">{{ step.title }}</div>
                    </div>
                </div>
            </div>
            
            <div class="signio-question">
                <!-- Wizard card - only show current step -->
                <div v-for="(card, idx) in cards" :key="card.title">
                    <transition name="card">
                        <div v-if="idx === current_step" class="card card-open card-wrapper">
                            <div class="card-header d-none d-md-flex">
                                <h6 class="mb-0">{{ card.title }}</h6>
                            </div>
                            <div class="card-body">
                                <div class="card-content">
                                    <div v-for="(comp, compIdx) in card.components" :key="comp">
                                        <component 
                                            :is="comp"
                                            :ref="`step-${idx}`" 
                                            @validity-change="on_validity_change"
                                            @previous="prev_step"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div v-else class="loading-container d-flex justify-content-center align-items-center" style="min-height: 60vh;">
            <div class="text-center">
            <div class="loading-spinner mb-3">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
            </div>
            <p class="loading-text">Loading...</p>
            </div>
        </div>

    </div>
</div>